import { createContext } from "react";
import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";
import { BetSlipReceiptModalStore } from "@state/stores/my-bets/BetSlipReceiptModalStore";

export const BetDetailsModalStoreContext =
	// @ts-expect-error
	createContext<BetDetailsModalStore | BetSlipReceiptModalStore>(null);
